// External Dependencies
import React from 'react';

// Internal Dependencies
import SnapstyrComponent from '../snapstyr/snapstyr';

const Snapstyr = (props) => (
  <SnapstyrComponent
    {...props}
  />
);

export default Snapstyr;
